import React, { useState } from 'react';
import MainContent from '../layout/MainContent';
import CharacterList from './characters/CharacterList';
import { ICON_NEW } from '../extras/icons';
import CharacterForm from './characters/CharacterForm';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { addCharactersAction } from '../../actions/charactersActions';
import AuthoritiesService from '../../services/AuthoritiesService';
import { PARAMETROS_CREAR } from '../../data/objects';
//Función principal
const Characters = () => {
    //Inicializo el state local
    const [show, setShow] = useState(false);
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Manejo el insert
    const handleCreate = () => {
        //Llamo al dispatch
        dispatch( addCharactersAction(handleOpen) );
    }
    //Nodos
    const nodes = [];
    //Actions
    const actions = [{
        title: 'NUEVO',
        css: 'success',
        icon: <ICON_NEW className="fa-sm text-white-50" />,
        handle: handleCreate,
        granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_CREAR)
    }];
    //Manejo la apertura de la ventana
    const handleOpen = () => {
        setShow(true);
    }
    //Manejo el cierre de la ventana
    const handleClose = () => {
        setShow(false);
    }
    //Renderizo
    return (
        <React.Fragment>
            <MainContent 
                title='Carácteres' 
                subtitle='Personas' 
                nodes={nodes}
                actions={actions}
                component={CharacterList}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />

            <CharacterForm
                show={show}
                handleClose={handleClose}
            />
        </React.Fragment>
    );
};

export default Characters;